import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { translations } from '../../../../locales/translations';
import { DisplayBooleanHorizontal } from './DisplayBooleanHorizontal';
import { DisplayFieldHorizontal } from './DisplayFieldHorizontal';
import { useSelector } from 'react-redux';
import {
  selectAllPreviousRecurring, selectContractInfoView,
  selectPreviewMode,
  selectPreviousRecurring,
  selectRecurringView,
} from '../slice/selectors';
import { QuoteItemCard } from './QuoteItemCard';
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@material-ui/core';
import { LoadingIndicator } from '../../../components/LoadingIndicator';
import { useTranslation } from 'react-i18next';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { RecurringData } from '../slice/types';
import { biType } from '../../../../locales/types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export function RecurringItems(props) {
  const { recurringData } = props;
  const { t } = useTranslation();
  const previousRecurringData: RecurringData | undefined = useSelector(selectPreviousRecurring);
  const allPreviousRecurringData = useSelector(selectAllPreviousRecurring);
  const recurringView = useSelector(selectRecurringView);
  const contractInfoView = useSelector(selectContractInfoView)
  const [displayData, setDisplayData] = useState(recurringData);
  const [highlightChange, setHighlightChange] = useState(false);
  const previewMode = useSelector(selectPreviewMode);
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const RecurringTab = () => {
    if(allPreviousRecurringData.length >0){
    return (
      <div>
        <h4>{t(translations.contractDetail.previousRecurring)}</h4>
      <AppBar position="static">
      <Tabs style={{backgroundColor: 'black'}} value={value} onChange={handleChange}>
        {
          allPreviousRecurringData.map((item, index) => {
            return  <Tab label={item.contractNo} key={item.index} {...a11yProps(item.index)} />
          })
        }
      </Tabs>
      </AppBar>
        {
          allPreviousRecurringData.map((item) => {
            return (
              <TabPanel value={value} index={item.index} key={item.index}>
                  <div className='recurring-item-container'>
                    {item.detail.recurringItems.map((item, index) => (
                      <QuoteItemCard
                        key={index}
                        data={item}
                        viewChangeData={null}
                        displayType={biType.RECURRING}
                      />
                    ))}
                  </div>
              </TabPanel>
            )
          })
        }
      </div>
    )
    } else {
      if(previousRecurringData) {
        return (
          <div className='recurring-item-container'>
            <h4>{t(translations.contractDetail.previousRecurring)}</h4>
            <Tabs style={{backgroundColor: 'black'}} value={value} onChange={handleChange}>
              <Tab label={contractInfoView?.renewedFromContract} {...a11yProps(0)} />
            </Tabs>
          {previousRecurringData.recurringItems.map((item, index) => (
            <QuoteItemCard
              key={index}
              data={item}
              viewChangeData={null}
              displayType={biType.RECURRING}
            />
          ))}
        </div>
        )
      } else {
        return <></>
      }
    }
  }

  React.useEffect(() => {
    if (previewMode && recurringView) {
      setHighlightChange(true);
      setDisplayData(recurringView);
    } else {
      setDisplayData(recurringData);
    }
  }, [previewMode]);

  React.useEffect(() => {
    if (!previewMode) {
      setDisplayData(recurringData);
    } else if (recurringView) {
      setDisplayData(recurringView);
    }
  }, [recurringData]);

  return (
    <Wrapper>
      {displayData && recurringData ? (
        <div>
          <Grid container className='header'>
            <Grid item xs={12} md={4}>
              <DisplayBooleanHorizontal
                value={displayData.startDateTBC}
                label={translations.contractDetail.startDateTBC}
                displayChange={highlightChange && displayData.startDateTBC !== recurringData.startDateTBC}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DisplayFieldHorizontal
                label={translations.contractDetail.billingCycle}
                value={displayData.billingCycle}
                displayChange={highlightChange && displayData.billingCycle !== recurringData.billingCycle}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DisplayFieldHorizontal
                label={translations.contractDetail.paymentTerms}
                value={displayData.paymentTerms}
                displayChange={highlightChange && displayData.paymentTerms !== recurringData.paymentTerms}
              />
            </Grid>
          </Grid>
          {recurringData.recurringItems.map((item, index) => (
            <QuoteItemCard key={index} data={item}
                           viewChangeData={recurringView ? recurringView.recurringItems[index] : null}
                           displayType={biType.RECURRING} />
          ))}
          {previewMode && displayData.newItems && displayData.newItems.map((item, index) => (
            <QuoteItemCard key={'newItems'+index} data={item} isNewItem={true}
                           viewChangeData={null}
                           displayType={biType.RECURRING} />
          ))}

          <RecurringTab />
        </div>
      ) : (
        <LoadingIndicator />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: ${p => p.theme.containerBackground};
  font-size: 12px;
  border-radius: 5px;

  .header {
    display: flex;
    margin-bottom: 5px;
  }

  .previous-recurr {
    padding-top: 5px;
    font-size: 14px;
  }

  .MuiAccordionSummary-root {
    height: 50px;
  }

  .MuiAccordionSummary-root.Mui-expanded {
    min-height: 50px;
  }

  .MuiAccordion-root.Mui-expanded {
    margin: 0;
  }

  .accordion-summary {
    border-radius: 5px !important;
    font-size: 14px;
    background-color: ${p => p.theme.borderLight};
    border: 1px solid ${p => p.theme.textSecondary};
  }

  .recurring-item-container {
    width: 100%;
  }
`;
